<template>
    <div>
        <base-loading :visible="isLoading" />
        <base-modal :isOpen="isOpen" :title="$t('grace_period') | capitalize" @close="$emit('close')">
            <!-- Body -->
            <template #body>

                <vs-row class="mb-4">
                    <vs-col>
                        <vs-input type="text" :label="$t('client') | capitalize"
                            :placeholder="$t('client') | capitalize" v-model="item.ClientName" class="w-full"
                            disabled />
                    </vs-col>
                </vs-row>

                <vs-row class="mb-4">
                    <vs-col>
                        <vs-input type="number" :label="$t('grace_period') | capitalize"
                            :placeholder="$t('grace_period') | capitalize" v-model="gracePeriod" class="w-full" />
                    </vs-col>
                </vs-row>
            </template>

            <!-- Footer -->
            <template #footer>
                <vs-button color="danger" type="border" @click="$emit('close')"> {{ $t('cancel') | capitalize }}
                </vs-button>
                <vs-button color="danger" @click="handleSubmit()" :disabled="!isValid"> {{ $t('submit') | capitalize }} </vs-button>
            </template>
        </base-modal>
    </div>
</template>

<script>
import BaseModal from '@/views/app/components/modals/BaseModal.vue'
import BaseLoading from '@/views/app/components/loading/BaseLoading.vue';

import request from '../request'
export default {
    name: 'EditGracePeriod',
    components: { BaseModal, BaseLoading },
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        item: {
            type: Object,
            default: () => ({ ClientId: null, ClientName: null, days: '48', gracePeriod: 0 })
        }
    },
    data() {
        return {
            clientId: '',
            clientName: '',
            days: '',
            gracePeriod: '',
            isLoading: false
        }
    },
    watch: {
        isOpen(newVal) {
            if (newVal) {
                this.gracePeriod = this.item.gracePeriod
            }

        }
    },
    computed:{
        isValid(){
            if(this.gracePeriod != null && this.gracePeriod != ''){
                 return this.gracePeriod > 0
            }
            return false
        }
    },
    methods: {
        handleSubmit() {
            const payload = {
                client_id: this.item.ClientId,
                days: this.gracePeriod,
            }
            this.isLoading = true
            request.updateGracePeriod(payload)
                .then(response => {
                    this.$vs.notify({
                        color: 'success',
                        title: 'Success',
                        text: 'Updated.'
                    })
                    this.isLoading = false
                    this.$emit('close')
                    this.$emit('updated')
                    //console.log(response)
                })
                .catch(response => {
                    this.isLoading = false
                    this.$vs.notify({
                        color: 'warning',
                        title: 'Oops!',
                        text: 'Something went wrong during the update.'
                    })
                    //console.log(response)
                })
        }
    }
}

</script>

<style scoped></style>
